// comms-errors.data.ts
//
// Patient messaging. See router/messages for the flow's identity challenge.
//
// ENG-21798: the codes are the ones the endpoints actually send —
// PatientMessageAccessChecker::REASON_* and DateOfBirthMismatchException. They were
// invented before, so every comms failure resolved to `unknown-error`.

import { ErrorEntry } from './error-metadata.types';

export const commsErrors = {
  'message-expired': {
    message:
      'This link has expired, so the message can no longer be opened. Contact your GP practice if you still need to read it.',
    title: 'This link has expired',
    showBackButton: false,
  },
  'message-locked': {
    // `{lockedUntil}` is the ATOM timestamp the endpoint sends beside the code; the line
    // is dropped when it is absent — see interpolateErrorMessage.
    message:
      'You have entered an incorrect date of birth too many times, so this message is temporarily locked.\nYou can try again after {lockedUntil}.',
    title: 'This message is temporarily locked',
    showBackButton: false,
  },
  'message-not-found': {
    message:
      'This message could not be found. Check the link in your email or text message, or contact your GP practice.',
    title: 'This message could not be found',
    showBackButton: false,
  },
  'message-conversation-closed': {
    message:
      'This conversation has been closed, so a reply can no longer be added to it. Contact your GP practice if you still need help.',
    title: 'This conversation is closed',
    showBackButton: false,
  },
  'date-of-birth-mismatch': {
    message:
      'The date of birth you entered does not match our records. Please check it and try again.',
    title: 'Form validation error below date of birth input.',
    redirectToError: false,
  },
} satisfies Record<string, ErrorEntry>;
